// src/pages/admin/tabs/parts/PaymentPlansPanel.jsx
import React from 'react';
import { AdminAPI } from '../../../../api/admin';
import { Card, Row2, Field, Actions, Btn, Badge } from '../../ui';

function PlanEditor({ plan, onSave, onDelete }) {
  const [form, setForm] = React.useState({
    title_ru: plan?.title_ru || plan?.title || '',
    title_en: plan?.title_en || '',
    title_zh: plan?.title_zh || '',
    description_ru: plan?.description_ru || '',
    description_en: plan?.description_en || '',
    description_zh: plan?.description_zh || '',
    is_active: plan?.is_active ?? true,
    sort_order: plan?.sort_order ?? 0,
  });
  const [busy, setBusy] = React.useState(false);
  const planId = plan?.id;

  const save = async () => {
    setBusy(true);
    try {
      await AdminAPI.updatePaymentPlan(planId, {
        ...form,
        is_active: !!form.is_active,
        sort_order: Number(form.sort_order) || 0,
      });
      onSave && onSave();
    } finally { setBusy(false); }
  };
  const del = async () => {
    if (!window.confirm('Удалить план?')) return;
    setBusy(true);
    try { await AdminAPI.deletePaymentPlan(planId); onDelete && onDelete(); }
    finally { setBusy(false); }
  };

  return (
    <Card style={{marginTop:8}}>
      <h4>План оплаты #{planId}</h4>
      <Row2>
        <Field>Название RU
          <input value={form.title_ru} onChange={e=>setForm(f=>({...f, title_ru:e.target.value}))}/>
        </Field>
        <Field>Название EN
          <input value={form.title_en} onChange={e=>setForm(f=>({...f, title_en:e.target.value}))}/>
        </Field>
      </Row2>
      <Field>Название ZH (中文)
        <input value={form.title_zh} onChange={e=>setForm(f=>({...f, title_zh:e.target.value}))}/>
      </Field>
      <Row2>
        <Field>Описание RU
          <textarea rows={3} value={form.description_ru} onChange={e=>setForm(f=>({...f, description_ru:e.target.value}))}/>
        </Field>
        <Field>Описание EN
          <textarea rows={3} value={form.description_en} onChange={e=>setForm(f=>({...f, description_en:e.target.value}))}/>
        </Field>
      </Row2>
      <Field>Описание ZH (中文)
        <textarea rows={3} value={form.description_zh} onChange={e=>setForm(f=>({...f, description_zh:e.target.value}))}/>
      </Field>
      <Row2>
        <Field>Активен
          <select value={form.is_active ? '1':'0'} onChange={e=>setForm(f=>({...f, is_active:e.target.value==='1'}))}>
            <option value="1">Да</option><option value="0">Нет</option>
          </select>
        </Field>
        <Field>Сортировка
          <input type="number" value={form.sort_order} onChange={e=>setForm(f=>({...f, sort_order:e.target.value}))}/>
        </Field>
      </Row2>

      {/* Стадии */}
      <StagesEditor plan={plan} onChanged={onSave}/>
      <Actions style={{marginTop:10}}>
        <Btn $kind="primary" onClick={save} disabled={busy}>{busy ? 'Сохранение…':'Сохранить план'}</Btn>
        <Btn onClick={del} disabled={busy}>Удалить план</Btn>
      </Actions>
    </Card>
  );
}

function StagesEditor({ plan, onChanged }) {
  const [adding, setAdding] = React.useState(false);
  const [form, setForm] = React.useState({
    percent: '', label_ru: '', label_en: '', label_zh: '',
  });

  const add = async ()=>{
    if (!form.percent) { alert('Укажите percent'); return; }
    setAdding(true);
    try{
      await AdminAPI.createPaymentStage(plan.id, {
        percent: form.percent,
        label_ru: form.label_ru || undefined,
        label_en: form.label_en || undefined,
        label_zh: form.label_zh || undefined,
      });
      setForm({ percent:'', label_ru:'', label_en:'', label_zh:'' });
      onChanged && onChanged();
    }finally{ setAdding(false); }
  };

  const update = async (s, patch)=>{
    await AdminAPI.updatePaymentStage(s.id, patch);
    onChanged && onChanged();
  };
  const del = async (s)=>{
    if (!window.confirm('Удалить этап?')) return;
    await AdminAPI.deletePaymentStage(s.id);
    onChanged && onChanged();
  };

  const stages = plan?.stages || [];

  return (
    <Card style={{marginTop:8, background:'#fbfbfb'}}>
      <h5>Этапы</h5>
      {stages.length===0 && <div style={{color:'#777'}}>Этапов нет</div>}
      {stages.map(s=>(
        <div key={s.id} style={{display:'grid', gap:8, padding:'8px 0', borderBottom:'1px dashed var(--bdr)'}}>
          <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
            <Badge>%: <b>{s.percent}</b></Badge>
            {s.label_ru && <Badge>RU: {s.label_ru}</Badge>}
            {s.label_en && <Badge>EN: {s.label_en}</Badge>}
            {s.label_zh && <Badge>ZH: {s.label_zh}</Badge>}
          </div>
          <Row2>
            <Field>%<input defaultValue={s.percent} onBlur={e=>update(s,{percent:e.target.value})}/></Field>
            <Field>RU<label /><input defaultValue={s.label_ru||''} onBlur={e=>update(s,{label_ru:e.target.value})}/></Field>
          </Row2>
          <Row2>
            <Field>EN<label /><input defaultValue={s.label_en||''} onBlur={e=>update(s,{label_en:e.target.value})}/></Field>
            <Field>ZH (中文)<label /><input defaultValue={s.label_zh||''} onBlur={e=>update(s,{label_zh:e.target.value})}/></Field>
          </Row2>
          <Actions><Btn onClick={()=>del(s)}>Удалить этап</Btn></Actions>
        </div>
      ))}

      <h5 style={{marginTop:8}}>Добавить этап</h5>
      <Row2>
        <Field>%<input value={form.percent} onChange={e=>setForm(f=>({...f, percent:e.target.value}))} placeholder="напр. 10"/></Field>
        <Field>Label RU<input value={form.label_ru} onChange={e=>setForm(f=>({...f, label_ru:e.target.value}))}/></Field>
      </Row2>
      <Row2>
        <Field>Label EN<input value={form.label_en} onChange={e=>setForm(f=>({...f, label_en:e.target.value}))}/></Field>
        <Field>Label ZH (中文)<input value={form.label_zh} onChange={e=>setForm(f=>({...f, label_zh:e.target.value}))}/></Field>
      </Row2>
      <Actions>
        <Btn $kind="primary" onClick={add} disabled={adding}>{adding ? 'Добавление…':'Добавить этап'}</Btn>
      </Actions>
    </Card>
  );
}

export default function PaymentPlansPanel({ propertyId, propertyType = 'regular' }) {
  const [items, setItems] = React.useState([]);
  const [msg, setMsg] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [addForm, setAddForm] = React.useState({ 
    title_ru:'', title_en:'', title_zh:'', 
    description_ru:'', description_en:'', description_zh:'', 
    is_active:true, sort_order:0 
  });

  // Определяем API методы в зависимости от типа объекта
  const getApiMethods = () => {
    switch (propertyType) {
      case 'foreign':
        return {
          list: AdminAPI.listForeignPaymentPlans,
          create: AdminAPI.createForeignPaymentPlan,
        };
      case 'suburban':
        return {
          list: AdminAPI.listSuburbanPaymentPlans,
          create: AdminAPI.createSuburbanPaymentPlan,
        };
      case 'commercial-rent':
        return {
          list: AdminAPI.listCommercialRentPaymentPlans,
          create: AdminAPI.createCommercialRentPaymentPlan,
        };
      case 'parking':
        return {
          list: AdminAPI.listParkingPaymentPlans,
          create: AdminAPI.createParkingPaymentPlan,
        };
      default:
        return {
          list: AdminAPI.listPaymentPlans,
          create: AdminAPI.createPaymentPlan,
        };
    }
  };

  const api = React.useMemo(() => getApiMethods(), [propertyType]);

  const load = React.useCallback(async ()=>{
    setBusy(true); setMsg('');
    try{
      const d = await api.list(propertyId, { locale: 'ru' });
      setItems(d?.items || d || []);
    }catch(e){ setMsg(e.message || 'Не удалось загрузить планы'); }
    finally{ setBusy(false); }
  }, [propertyId, api]);

  React.useEffect(()=>{ load(); }, [load]);

  const add = async ()=>{
    if (!addForm.title_ru && !addForm.title_en) { alert('Название обязательно'); return; }
    setBusy(true); setMsg('');
    try{
      await api.create(propertyId, {
        title_ru: addForm.title_ru || undefined,
        title_en: addForm.title_en || undefined,
        title_zh: addForm.title_zh || undefined,
        description_ru: addForm.description_ru || undefined,
        description_en: addForm.description_en || undefined,
        description_zh: addForm.description_zh || undefined,
        is_active: !!addForm.is_active,
        sort_order: Number(addForm.sort_order) || 0,
      });
      setAddForm({ title_ru:'', title_en:'', title_zh:'', description_ru:'', description_en:'', description_zh:'', is_active:true, sort_order:0 });
      await load();
    }catch(e){ setMsg(e.message || 'Не удалось создать план'); }
    finally{ setBusy(false); }
  };

  return (
    <Card>
      <h3>Условия оплаты</h3>
      {msg && <div style={{color:'#777', marginBottom:8}}>{msg}</div>}

      <Card style={{background:'#fbfbfb'}}>
        <h4>Добавить план</h4>
        <Row2>
          <Field>Название RU<input value={addForm.title_ru} onChange={e=>setAddForm(f=>({...f, title_ru:e.target.value}))}/></Field>
          <Field>Название EN<input value={addForm.title_en} onChange={e=>setAddForm(f=>({...f, title_en:e.target.value}))}/></Field>
        </Row2>
        <Field>Название ZH (中文)<input value={addForm.title_zh} onChange={e=>setAddForm(f=>({...f, title_zh:e.target.value}))}/></Field>
        <Row2>
          <Field>Описание RU<textarea rows={2} value={addForm.description_ru} onChange={e=>setAddForm(f=>({...f, description_ru:e.target.value}))}/></Field>
          <Field>Описание EN<textarea rows={2} value={addForm.description_en} onChange={e=>setAddForm(f=>({...f, description_en:e.target.value}))}/></Field>
        </Row2>
        <Field>Описание ZH (中文)<textarea rows={2} value={addForm.description_zh} onChange={e=>setAddForm(f=>({...f, description_zh:e.target.value}))}/></Field>
        <Row2>
          <Field>Активен
            <select value={addForm.is_active?'1':'0'} onChange={e=>setAddForm(f=>({...f, is_active: e.target.value==='1'}))}>
              <option value="1">Да</option><option value="0">Нет</option>
            </select>
          </Field>
          <Field>Сортировка
            <input type="number" value={addForm.sort_order} onChange={e=>setAddForm(f=>({...f, sort_order:e.target.value}))}/>
          </Field>
        </Row2>
        <Actions><Btn $kind="primary" onClick={add} disabled={busy}>{busy?'Создаю…':'Создать план'}</Btn></Actions>
      </Card>

      {items.map(p => (
        <PlanEditor key={p.id} plan={p} onSave={load} onDelete={load}/>
      ))}
      {!items.length && <div style={{color:'#777', marginTop:8}}>Планов пока нет</div>}
    </Card>
  );
}
